import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { getBrandUsers } from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import RoleFilterModal from "./RoleFilterModal";
import UserCreateModal from "./UserCreateModal";
import AdminMenu from "../../AdminMenu";

const UserList = () => {
  const navigate = useNavigate();
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [storeUserData, setStoreUserData] = useState([]);
  const [selectedUserItemValue, setSelectedUserItemValue] = useState(null);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const isWareHouseModel = brandProfileData.wareHouseModel;
  const [loading, setLoading] = useState(false);

  const fetchStoreUser = () => {
    setLoading(true);
    getBrandUsers(brandId)
      .then((response) => {
        if (!response.data.error) {
          const users = response.data;
          const riderUsers = users.filter((user) => user.role === "ROLE_RIDER");
          const storeUsers = users.filter((user) => user.role === "ROLE_STORE");
          const warehouseUsers = users.filter(
            (user) => user.role === "ROLE_WAREHOUSE"
          );
          const warehouseStageUsers = users.filter(
            (user) => user.role === "ROLE_WAREHOUSE_USER"
          );

          setStoreUserData({
            ROLE_RIDER: riderUsers,
            ROLE_STORE: storeUsers,
            ROLE_WAREHOUSE: warehouseUsers,
            ROLE_WAREHOUSE_USER: warehouseStageUsers,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermClean, setSearchTermClean] = useState(false);
  const [userCreateModalVisible, setUserCreateModalVisible] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);

  const [roleFilterModalVisible, setRoleFilterModalVisible] = useState(false);

  const receiveDataFromUserCreateModal = ({ success }) => {
    if (success) {
      fetchStoreUser();
      setSelectedUserItemValue(null);
    }
  };

  const receiveDataFromRoleFilterModal = (selectedRole) => {
    setSelectedRoles(selectedRole);
  };

  const filterUserList = () => {
    const filteredRiderUsers = storeUserData?.ROLE_RIDER?.filter((item) => {
      const fullName =
        item.firstName.toLowerCase() + " " + item.lastName.toLowerCase();
      const matchesSearchTerm = fullName.includes(searchTerm.toLowerCase());
      const matchesSelectedRole =
        selectedRoles.length === 0 || selectedRoles.includes(item.role);
      return matchesSearchTerm && matchesSelectedRole;
    });

    const filteredStoreUsers = storeUserData?.ROLE_STORE?.filter((item) => {
      const fullName =
        item.firstName.toLowerCase() + " " + item.lastName.toLowerCase();
      const matchesSearchTerm = fullName.includes(searchTerm.toLowerCase());
      const matchesSelectedRole =
        selectedRoles.length === 0 || selectedRoles.includes(item.role);
      return matchesSearchTerm && matchesSelectedRole;
    });
    const filteredWarehouseUsers = storeUserData?.ROLE_WAREHOUSE?.filter(
      (item) => {
        const fullName =
          item.firstName.toLowerCase() + " " + item.lastName.toLowerCase();
        const matchesSearchTerm = fullName.includes(searchTerm.toLowerCase());
        const matchesSelectedRole =
          selectedRoles.length === 0 || selectedRoles.includes(item.role);
        return matchesSearchTerm && matchesSelectedRole;
      }
    );

    const filteredWarehouseStageUsers =
      storeUserData?.ROLE_WAREHOUSE_USER?.filter((item) => {
        const fullName =
          item.firstName.toLowerCase() + " " + item.lastName.toLowerCase();
        const matchesSearchTerm = fullName.includes(searchTerm.toLowerCase());
        const matchesSelectedRole =
          selectedRoles.length === 0 || selectedRoles.includes(item.role);
        return matchesSearchTerm && matchesSelectedRole;
      });

    return {
      ROLE_RIDER: filteredRiderUsers,
      ROLE_STORE: filteredStoreUsers,
      ROLE_WAREHOUSE: filteredWarehouseUsers,
      ROLE_WAREHOUSE_USER: filteredWarehouseStageUsers,
    };
  };

  const filteredUserData = filterUserList();

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchTermClean(true);
  };

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      const formattedCreatedDate =
        item.createdDate === null ? "" : formatDate(item.createdDate);
      const formattedNextRenewalDate =
        item.nextRenewalOn === null ? "" : formatDate(item.nextRenewalOn);
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.firstName + " " + item.lastName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Register On :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formattedCreatedDate}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      User Id :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.userLoginId}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() => {
                      setUserCreateModalVisible(true);
                      setSelectedUserItemValue(item);
                    }}
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Next Renewal Date :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formattedNextRenewalDate}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Register On :
                  </p>
                  {item.enabled === true ? (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize mr-2">
                        Active{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                        }
                      />
                    </div>
                  ) : (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize mr-2">
                        DeActive{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                        }
                      />
                    </div>
                  )}
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Assigned To :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item?.mappedWith}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                User Management
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2 mx-5 flex flex-1">
        <div
          onClick={() => setUserCreateModalVisible(true)}
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
        >
          <div>
            <img
              src={
                "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
              }
              style={{ width: 27 }}
            />
          </div>
        </div>
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search User"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        {searchTerm ? (
          <div
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            onClick={handleClearSearch}
          >
            <div>
              <p className="text-4xl font-bold " style={{ color: "red" }}>
                X
              </p>
            </div>
          </div>
        ) : (
          <div
            onClick={() => setRoleFilterModalVisible(true)}
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          >
            <div>
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                style={{ width: 27 }}
              />
            </div>
          </div>
        )}
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : storeUserData?.ROLE_STORE?.length > 0 ||
          storeUserData?.ROLE_RIDER?.length > 0 ||
          storeUserData?.ROLE_WAREHOUSE?.length > 0 ||
          storeUserData?.ROLE_WAREHOUSE_USER?.length > 0 ? (
          <div>
            {storeUserData?.ROLE_STORE?.length > 0 &&
              filteredUserData?.ROLE_STORE?.length > 0 && (
                <div>
                  <div
                    className="flex-1  surface-0"
                    style={{ "--surface-0": "#EAEFF5" }}
                  >
                    <div className="flex justify-content-between mx-4">
                      <div className="py-1">
                        <p className=" text-2xl  font-bold ">ROLE STORE</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    {renderCardItem(
                      filteredUserData.ROLE_STORE || storeUserData.ROLE_STORE
                    )}
                  </div>
                </div>
              )}

            {storeUserData?.ROLE_RIDER?.length > 0 &&
              filteredUserData?.ROLE_RIDER?.length > 0 && (
                <div>
                  <div
                    className="flex-1  surface-0"
                    style={{ "--surface-0": "#EAEFF5" }}
                  >
                    <div className="flex justify-content-between mx-4">
                      <div className="py-1">
                        <p className=" text-2xl  font-bold ">ROLE RIDER</p>
                      </div>
                    </div>
                  </div>

                  {renderCardItem(
                    filteredUserData.ROLE_RIDER || storeUserData.ROLE_RIDER
                  )}
                </div>
              )}

            {storeUserData?.ROLE_WAREHOUSE?.length > 0 &&
              filteredUserData?.ROLE_WAREHOUSE?.length > 0 && (
                <div>
                  <div
                    className="flex-1  surface-0"
                    style={{ "--surface-0": "#EAEFF5" }}
                  >
                    <div className="flex justify-content-between mx-4">
                      <div className="py-1">
                        <p className=" text-2xl  font-bold ">ROLE WAREHOUSE</p>
                      </div>
                    </div>
                  </div>

                  {renderCardItem(
                    filteredUserData.ROLE_WAREHOUSE ||
                      storeUserData.ROLE_WAREHOUSE
                  )}
                </div>
              )}

            {storeUserData?.ROLE_WAREHOUSE_USER?.length > 0 &&
              filteredUserData?.ROLE_WAREHOUSE_USER?.length > 0 && (
                <div>
                  <div
                    className="flex-1  surface-0"
                    style={{ "--surface-0": "#EAEFF5" }}
                  >
                    <div className="flex justify-content-between mx-4">
                      <div className="py-1">
                        <p className=" text-2xl  font-bold ">ROLE WAREHOUSE USER</p>
                      </div>
                    </div>
                  </div>
                  {renderCardItem(
                    filteredUserData.ROLE_WAREHOUSE_USER ||
                      storeUserData.ROLE_WAREHOUSE_USER
                  )}
                </div>
              )}
          </div>
        ) : (
          <div className="flex justify-content-center">
            <p className="text-xl font-medium">No Order Found</p>
          </div>
        )}
      </div>
      
        <AdminMenu setVisible={setVisible} visible={visible} />
      
      <UserCreateModal
        setUserCreateModalVisible={setUserCreateModalVisible}
        userCreateModalVisible={userCreateModalVisible}
        sendDataToUserList={receiveDataFromUserCreateModal}
        brandId={brandId}
        selectedUserItemValue={selectedUserItemValue}
        isWareHouseModel={isWareHouseModel}
      />
      <RoleFilterModal
        setRoleFilterModalVisible={setRoleFilterModalVisible}
        roleFilterModalVisible={roleFilterModalVisible}
        sendDataToRoleFromFilter={receiveDataFromRoleFilterModal}
        brandId={brandId}
        isWareHouseModel={isWareHouseModel}
      />
    </div>
  );
};

export default UserList;
